import { render, staticRenderFns } from "./MobileProfileIdentities.vue?vue&type=template&id=753bb183&"
import script from "./MobileProfileIdentities.vue?vue&type=script&lang=js&"
export * from "./MobileProfileIdentities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports